import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import NavbarComp from '../../shared/components/Navbar';
import { IoAddCircleOutline } from 'react-icons/io5';
import AlertMessage from '../../shared/components/Alert';
import { usePromoProduct } from './hooks/usePromoProduct';
import PromoProductTable from './components/PromoProductTable';
import PromoProductAddModal from './components/PromoProductAddModal';
import Swal from 'sweetalert2';

const PromoProductPage = () => {

  const {
    addPromoProduct,
    alert,
    error,
    loading,
    fetchPromoProduct,
    fetchPromoProductById,
    editPromoProduct,
    updateOnActive,
    promoProduct,
    promoProductAll,
    fetchPromoProductAll,
    removePromoProduct } = usePromoProduct()

  const [showModal, setShowModal] = useState(false);

  const [editingData, setEditingData] = useState(null);

  const handleOpenModal = (row) => {
    setShowModal(true);
  };


  useEffect(() => {
    fetchPromoProductAll()
  }, [promoProductAll]);

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingData(null);  // Reset after closing
  };

  const handleEditPromoProduct = (updatedPromoProduct) => {
    setEditingData(updatedPromoProduct)
    handleOpenModal(updatedPromoProduct)
  };

  const handleDeleteTypeProduct = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        removePromoProduct(id.id);
        Swal.fire("Deleted!", "The item has been deleted.", "success");
      }
    });
  };

  return (
    <>
      <NavbarComp />
      {/* <AlertMessage show={alert.show} variant={alert.variant} message={alert.message} onClose={() => { }} /> */}
      <Container fluid className="mt-2 mt-md-5">
        <Button Tooltip={"test"} variant="outline-success" className="mb-2" onClick={handleOpenModal}>
          <IoAddCircleOutline size={32} />
        </Button>
        <PromoProductTable
          loading={loading}
          promoProductTables={promoProductAll}
          onEdit={handleEditPromoProduct}
          onDelete={handleDeleteTypeProduct}
          updateOnActive={updateOnActive}
        />
        <PromoProductAddModal
          show={showModal}
          handleClose={handleCloseModal}
          handleAddPromoProducts={addPromoProduct}
          parsingDataEdit={editingData}
          editPromoProduct={editPromoProduct}
        />
      </Container>
    </>
  );
};

export default PromoProductPage;
